import React, { useState, useEffect, useRef, forwardRef } from "react";
import DashboardHeader from "../components/Other/DashboardHeader";
import PageHeaderTitle from "../components/pages/PageHeaderTitle";
import PageContainer from "../components/pages/PageContainer";
import SettingsPageHeading from "../components/pages/SettingsPageHeading";
import {
  getProfile,
  updateProfile,
  s3Upload,
  tradingType,
  checkUsername,
  getCountries,
} from "../api/user";
import { useNavigate, useOutletContext } from "react-router-dom";
import NewTraderGuide from "../components/guide/NewTraderGuide";
import { useNewTraderGuide } from "../context/NewTraderGuideContext";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ProcessingButton from "../components/Skeleton/ProcessingButton";
import { SkeletonBlock } from "../components/Skeleton/Skeleton";
import { event } from "../utils/event";
import {
  SUBSCRIPTION_ENABLED,
  USERNAME_REGEX,
  sanitizeUsername,
  MIN_BIO_WORDS,
  countWords,
} from "../utils/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TraderIdentityRewardBanner from "../components/Other/TraderIdentityRewardBanner";
import Counter from "./Game/landing/wizard/Counter";

// Client: "if there is a character limit on the bio or background input fields,
// we should display the limit. Just like we do for league creation screens."
// Same live counter and hard stop as the league wizard; the limits themselves
// are the ones this screen already enforced on Save.
const BIO_MAX_CHARS = 250;
const BACKGROUND_MAX_CHARS = 50;

const DobInput = forwardRef(
  ({ value, onClick, className, placeholder }, ref) => (
    <input
      ref={ref}
      type="text"
      readOnly
      value={value}
      onClick={onClick}
      placeholder={placeholder}
      className={className}
    />
  ),
);
DobInput.displayName = "DobInput";

const EditProfile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [sidebarToggle] = useOutletContext();
  const token = localStorage.getItem("accessToken");
  const { guideActive, guideStep, advanceStep } = useNewTraderGuide();
  const persona = localStorage.getItem("qushi_onboarding_persona");
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setcountryCode] = useState("");
  const [phone, setPhoneNumber] = useState("");
  const [tradingStyle, setTrading] = useState("");
  const [chatType, setChat] = useState("");
  const [imgurl, setImgUrls] = useState([]);
  const [images, setImages] = useState([]);
  const [subscriptionPlanAmount, setSubscriptionPlanAmount] = useState("");
  const [bio, setBio] = useState("");
  const [title, setTitle] = useState("");
  const [username, setUsername] = useState("");
  const [username1, setUsername1] = useState("");
  const [link, setLink] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const imageInputRef = useRef(null);
  const [userNameError, setUserNameError] = useState("");
  const [trading, setTrade] = useState([]);

  const [date_of_birth, setDob] = useState("");
  const [maxDate, setMaxDate] = useState("");

  const [country_of_origin, setCountry] = useState("");
  const [countries, setCountries] = useState([]);
  const [inputsStatus, setInputsStatus] = useState({
    name: "",
    email: "",
    phone: "",
    countryCode: "",
    titile: "",
    link: "",
    bio: "",
    countryCode: "",
    tradingStyle: "",
    subscriptionPlanAmount,
    username: "",
    date_of_birth: "",
    country_of_origin: "",
  });
  const [uploadingImage, setUploadingImage] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isDataFeteched1, setisDataFeteched1] = useState(false);
  const numberMatch = /^\d+(\.\d+)?$/;
  const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/g;
  const userinfo = JSON.parse(localStorage.getItem("userInfo"));
  const [bioUploadStatus, setBioUploadStatus] = useState(null);
  const [rewardRefreshKey, setRewardRefreshKey] = useState(0);
  const [pictureUploadStatus, setPictureUploadStatus] = useState(
    userinfo?.picture_upload_status ?? null,
  );
  const [accountCreatedAt, setAccountCreatedAt] = useState(
    userinfo?.created_at ?? userinfo?.createdAt ?? null,
  );

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    if (user) {
      fetchProfile(user);
    }
    fetchFreshProfile();
  }, []);

  const fetchFreshProfile = async () => {
    try {
      const response = await getProfile();
      if (response?.data?.success && response.data.data) {
        fetchProfile(response.data.data);
        setBioUploadStatus(response.data.data.bio_upload_status ?? null);
        setPictureUploadStatus(
          response.data.data.picture_upload_status ?? null,
        );
        setAccountCreatedAt(response.data.data.created_at ?? null);
      }
    } catch (error) {
      console.error("Error fetching fresh profile:", error);
    }
  };

  useEffect(() => {
    if (!isDataFeteched1) fetchTrading();
  }, [isDataFeteched1]);

  useEffect(() => {
    const today = new Date();
    today.setFullYear(today.getFullYear() - 13);
    setMaxDate(today);
  }, []);

  const formatDateForDisplay = (date) => {
    if (!date) return "";
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const formatDateForBackend = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (date) => {
    if (date) {
      const localDate = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
      );
      setDob(localDate);
    } else {
      setDob(null);
    }
  };

  const fetchProfile = async (user) => {
    const profileData = user;
    setFullname(profileData.full_name || "");
    setEmail(profileData.email || "");
    setPhoneNumber(profileData.phone || "");
    setcountryCode(profileData.country_code || "");
    setTrading(profileData.trading_type_id || "");
    setTitle(profileData.title || "");
    setSubscriptionPlanAmount(profileData?.subscription_plan_amount || "");
    setBio(profileData.biography || "");
    setProfileImage({
      src: profileData.image,
      blob: null,
    });
    const imageStr = String(profileData.image || "");
    const isUploadedImage =
      imageStr.includes("s3_link") ||
      imageStr.includes("/upload/user/") ||
      (imageStr.length > 100 && imageStr.includes("amazonaws"));

    if (isUploadedImage) {
      setImgUrls(profileData.image);
    } else {
      setImgUrls([]);
    }
    setChat(profileData.is_chat_paid || "");
    setLink(profileData.link || "");
    setUsername(profileData.user_name || "");
    setUsername1(profileData.user_name);
    if (profileData.date_of_birth) {
      let parsedDate;

      if (profileData.date_of_birth.includes("T")) {
        parsedDate = new Date(profileData.date_of_birth);
      } else {
        const [year, month, day] = profileData.date_of_birth
          .split("-")
          .map(Number);
        parsedDate = new Date(year, month - 1, day);
      }

      setDob(parsedDate);
    }

    setCountry(profileData.country_of_origin || "");
  };

  const fetchTrading = async () => {
    try {
      const response = await tradingType();
      if (response?.data?.status == 200) {
        setTrade(response?.data?.data);
        setisDataFeteched1(true);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleImageUpload = async (e) => {
    try {
      setUploadingImage(true);
      const selectedFile = e.target.files[0];
      setProfileImage({
        src: URL.createObjectURL(selectedFile),
        blob: null,
      });
      if (!selectedFile) {
        console.error("No file selected for upload.");
        setUploadingImage(false);
        return;
      }

      const newImage = {
        id: null,
        image: null,
        blob: selectedFile,
        preview: URL.createObjectURL(selectedFile),
      };
      setImages([newImage]);
      const response = await s3Upload([newImage]);
      if (response && response.data && response.data.data) {
        const imagePath = response.data.data[0];
        setImgUrls(imagePath);
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setUploadingImage(false);
    }
  };

  useEffect(() => {
    const handleFlutterEvent = (event) => {
      const handleCustomProfileEvent = (event) => {
        const baseUrl = userinfo?.s3_url;
        setImgUrls(event?.detail?.image);
        setProfileImage({ src: baseUrl + event?.detail?.image });
      };
      window.addEventListener("myCustomProfileEvent", handleCustomProfileEvent);
    };

    window.addEventListener("flutterEvent", handleFlutterEvent);
    return () => window.removeEventListener("flutterEvent", handleFlutterEvent);
  }, [window.addEventListener, localStorage]);

  const handleUpdateProfile = async () => {
    if (saving) return;
    try {
      if (!fullname) {
        toast.error("Enter your name.");
        return;
      } else if (fullname.length > 40) {
        toast.error("Name must be 40 characters or fewer.");
        return;
      } else if (title.length > BACKGROUND_MAX_CHARS) {
        toast.error(
          `Background / Education must be ${BACKGROUND_MAX_CHARS} characters or fewer.`
        );
        return;
      } else if (bio.length > BIO_MAX_CHARS) {
        toast.error(`Bio must be ${BIO_MAX_CHARS} characters or fewer.`);
        return;
      }
      if (bio.trim() && countWords(bio) < MIN_BIO_WORDS) {
        toast.error(`Bio must be at least ${MIN_BIO_WORDS} words.`);
        return;
      }
      if (!tradingStyle) {
        toast.error("Choose a trading style.");
        return;
      }
      if (
        subscriptionPlanAmount &&
        !subscriptionPlanAmount.match(numberMatch)
      ) {
        toast.error("Subscription Amount should contain positive number only");
        return;
      }
      if (userNameError) {
        return;
      }
      if (!username) {
        toast.error("Enter a trader name.");
        return;
      }
      if (username.length > 20) {
        toast.error("Trader name must be 20 characters or fewer.");
        return;
      }
      if (!USERNAME_REGEX.test(username)) {
        toast.error(
          "Use lowercase letters, numbers, periods, or underscores. No spaces."
        );
        return;
      }
      if (phone && phone.length < 10) {
        toast.error("Phone number must be 10 digits!");
        return;
      }

      setSaving(true);

      const dataTrading =
        trading && trading.length > 0 && trading.map((val) => val?.id);

      const tradingStyle1 = tradingStyle && parseInt(tradingStyle);

      const isReadUrl =
        typeof imgurl === "string" && /^https?:\/\//i.test(imgurl);
      const imageToSubmit = isReadUrl ? "" : imgurl;

      const response = await updateProfile({
        full_name: fullname,
        email: email,
        countryCode: "+1",
        phone: phone,
        countryCode: countryCode,
        title: title,
        link: link,
        biography: bio,
        image: imageToSubmit,
        trading_type_id:
          dataTrading && dataTrading.includes(tradingStyle1)
            ? tradingStyle
            : trading[0]?.id,
        subscription_plan_amount: subscriptionPlanAmount,
        chat_type: chatType,
        user_name: username,
        date_of_birth: date_of_birth
          ? formatDateForBackend(date_of_birth)
          : null,
        country_of_origin: country_of_origin ? Number(country_of_origin) : null,
      });
      if (response.data.status === 200) {
        const isPendingReview =
          response.data.data?.profile_moderation_status === "pending_review";
        const userPayload = isPendingReview
          ? response.data.data.user
          : response.data.data;
        localStorage.setItem("userInfo", JSON.stringify(userPayload));
        localStorage.removeItem("img");
        localStorage.removeItem("image");
        setRewardRefreshKey((key) => key + 1);
        toast.success(
          isPendingReview
            ? response.data.message || response.data.data?.message
            : "Profile updated."
        );
        if (guideActive && persona === "creator" && guideStep === 1) {
          advanceStep(2);
        } else {
          window.scrollTo(0, 0);
          navigate("/profile");
        }
      } else {
        toast.error("Could not save your profile. Try again.");
      }
    } catch (error) {
      toast.error("Could not save your profile. Try again.");
      console.error("Error:", error);
    } finally {
      setSaving(false);
    }
  };
  useEffect(() => {
    if (email.length > 0) {
      setInputsStatus({
        ...inputsStatus,
        email: email.match(emailPattern) ? "valid" : "invalid",
      });
    }
  }, [email]);

  const fetchCountries = async (retriesLeft = 3) => {
    try {
      const response = await getCountries();
      const data = response?.data?.data;
      if (response?.data?.success && Array.isArray(data) && data.length) {
        setCountries(data);
        return;
      }
      throw new Error(response?.data?.message || "Empty country list");
    } catch (error) {
      console.error("Error fetching countries:", error);
      if (retriesLeft > 0) {
        setTimeout(() => fetchCountries(retriesLeft - 1), 1500);
      }
    }
  };

  useEffect(() => {
    fetchCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (subscriptionPlanAmount && subscriptionPlanAmount.length > 0) {
      setInputsStatus({
        ...inputsStatus,
        subscriptionPlanAmount: subscriptionPlanAmount.match(numberMatch)
          ? "valid"
          : "invalid",
      });
    }
  }, [subscriptionPlanAmount]);

  const handleChange = async (e) => {
    e.preventDefault();
    setUserNameError("");
    const userName = sanitizeUsername(e.target.value);
    setUsername(userName);
    if (userName.trim() != username1.trim()) {
      try {
        const response = await checkUsername({ user_name: userName });
        if (response?.data?.data.length > 0) {
          setUserNameError(response?.data?.message);
        } else {
          setUserNameError("");
        }
      } catch (error) {
        console.error("Error:", error);
        setUserNameError("");
      }
    }
  };
  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      <PageHeaderTitle title={t("Edit profile")} showDesktopTitle={false} />
      <PageContainer>
        <div className="px-4 pt-4 md:pt-10 md:px-0 md:max-w-4xl md:mx-auto">
          <SettingsPageHeading
            title={t("Edit profile")}
            className="mb-3 md:mb-4"
          />
          <div className="md:rounded-2xl md:border md:border-gray-200 md:bg-white md:p-6">
            <div className="mx-auto w-32 mb-3 mt-4">
              <div
                className="relative"
                aria-busy={uploadingImage ? "true" : undefined}
              >
                <img
                  src={profileImage?.src}
                  className="object-cover w-full border-4 border-gray-50/50 h-auto aspect-square mx-auto rounded-full"
                  alt=""
                />
                {uploadingImage && (
                  <span className="absolute inset-0 rounded-full overflow-hidden">
                    <SkeletonBlock
                      width="100%"
                      height="100%"
                      rounded="rounded-full"
                      className="opacity-80"
                    />
                  </span>
                )}
                <input
                  type="file"
                  ref={imageInputRef}
                  className="hidden"
                  name="image"
                  id="upload"
                  accept="image/*"
                  multiple
                  onChange={handleImageUpload}
                />
              </div>
            </div>
            {pictureUploadStatus === "under_review" ? (
              <div className="block mx-auto text-xs font-medium text-orange-600 mb-6 text-center">
                Picture pending
              </div>
            ) : (
              <>
                {pictureUploadStatus === "rejected" && (
                  <div className="block mx-auto text-xs font-medium text-red-600 text-center">
                    Picture not accepted
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => imageInputRef?.current?.click()}
                  className="block mx-auto text-xs font-medium text-primaryColor mb-6 hover:opacity-80 transition"
                >
                  Change picture
                </button>
              </>
            )}
            <div className="max-w-6xl mx-auto">
              <TraderIdentityRewardBanner
                userinfo={userinfo}
                profileImage={profileImage}
                imgurl={imgurl}
                bio={bio}
                country_of_origin={country_of_origin}
                picture_upload_status={pictureUploadStatus}
                bio_upload_status={bioUploadStatus}
                account_created_at={accountCreatedAt}
                refreshKey={rewardRefreshKey}
              />

              <h3 className="text-xs font-semibold tracking-wide text-primaryColor uppercase border-b border-gray-200 pb-1 mb-4">
                Account
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-5 md:items-start">
                <div className="mb-4">
                  <label className="block text-xs text-gray-500 mb-1">
                    Full Name <span className="text-primaryColor">*</span>
                  </label>
                  <input
                    type="text"
                    className={`border-2 px-2 py-2 rounded-lg w-full ${
                      inputsStatus.full_name === "invalid" &&
                      "border-2 !border-red-500"
                    }`}
                    placeholder="First and last name"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    required
                  />
                  <span className="text-[12px] text-gray-400">
                    Your name stays private, even in competitions.
                  </span>
                </div>
                <div className="mb-4">
                  <label className="block text-xs text-gray-500 mb-1">
                    Email Address <span className="text-primaryColor">*</span>
                  </label>
                  <input
                    type="email"
                    className={`border-2 px-2 py-2 rounded-lg w-full ${
                      inputsStatus.email === "invalid" &&
                      "border-2 !border-red-500"
                    }`}
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <h3 className="text-xs font-semibold tracking-wide text-primaryColor uppercase border-b border-gray-200 pb-1 mb-4 mt-8">
                Trading Identity
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-5 md:items-start">
                <div className="mb-4">
                  <label className="block text-xs text-gray-500 mb-1">
                    Trader Type <span className="text-primaryColor">*</span>
                  </label>
                  <select
                    className={`w-full border-2 px-2 py-2 border-gray-300 rounded-lg ${
                      inputsStatus.tradingStyle === "invalid"
                        ? "border-2 border-red-500"
                        : ""
                    }`}
                    value={tradingStyle}
                    onChange={(e) => setTrading(e.target.value)}
                  >
                    <option value="" disabled>
                      Select trader type
                    </option>
                    {/* Client: "I enter them in the backend in the order I want,
                        but the system sorts them alphabetically." Shown exactly
                        in the order the API returns - the order they were
                        entered in the admin panel. */}
                    {trading.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.type}
                      </option>
                    ))}
                  </select>
                  {SUBSCRIPTION_ENABLED ? (
                    <div className="relative flex items-center w-full mt-4">
                      <span className="absolute ml-5 mt-2.5 mb-[10px] text-lg text-black">
                        $
                      </span>
                      <input
                        type="text"
                        maxLength="6"
                        placeholder={t("Subscription Amount (In USD)")}
                        className={`border-2 px-2 py-2 rounded-lg pl-8 w-full ${
                          inputsStatus.subscriptionPlanAmount === "invalid"
                            ? "border-2 border-red-500"
                            : "border"
                        }`}
                        value={subscriptionPlanAmount}
                        onChange={(e) => {
                          const input = e.target.value;
                          const regex = /^\d*\.?\d{0,2}$/;
                          if (regex.test(input)) {
                            setSubscriptionPlanAmount(input);
                          }
                        }}
                      />
                    </div>
                  ) : null}
                </div>
                <div className="mb-4">
                  <label className="block text-xs text-gray-500 mb-1">
                    Username <span className="text-primaryColor">*</span>{" "}
                    <span className="text-[12px] font-normal text-gray-400">
                      Public on QUSHi
                    </span>
                  </label>
                  <input
                    type="text"
                    placeholder="yourname.trades"
                    maxLength={20}
                    autoCapitalize="none"
                    autoCorrect="off"
                    spellCheck={false}
                    className={`border-2 px-2 py-2 rounded-lg w-full ${
                      inputsStatus.titile === "invalid" &&
                      "border-2 !border-red-500"
                    }`}
                    value={username}
                    onChange={handleChange}
                  />
                  {userNameError ? (
                    <span style={{ color: "red" }} className="text-[12px]">
                      {userNameError}
                    </span>
                  ) : (
                    <span className="text-[12px] text-gray-400">
                      Lowercase letters, numbers, periods, and underscores.
                      <span className="hidden sm:inline"> No spaces.</span>
                    </span>
                  )}
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-xs text-gray-500 mb-1">Bio</label>
                <div className="relative">
                  <textarea
                    placeholder="What you trade, how you think, or what you're building."
                    rows={3}
                    maxLength={BIO_MAX_CHARS}
                    className={`w-full ${
                      inputsStatus.bio === "invalid"
                        ? "border-2 border-red-500"
                        : "border border-gray-300"
                    } rounded-lg px-2 pt-3 pb-7 border-2 block`}
                    value={bio}
                    onChange={(e) => setBio(e.target.value)}
                  />
                  <Counter value={bio} max={BIO_MAX_CHARS} />
                </div>
                <span className="text-[12px] text-gray-400">
                  At least {MIN_BIO_WORDS} words.
                </span>
              </div>
              <div className="mb-4">
                <label className="block text-xs text-gray-500 mb-1">
                  Background / Education
                </label>
                <div className="relative">
                  <input
                    type="text"
                    placeholder="School, club, work, or trading background"
                    maxLength={BACKGROUND_MAX_CHARS}
                    className={`border-2 px-2 pt-2 pb-6 rounded-lg w-full ${
                      inputsStatus.titile === "invalid" &&
                      "border-2 !border-red-500"
                    }`}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                  <Counter value={title} max={BACKGROUND_MAX_CHARS} />
                </div>
              </div>

              <h3 className="text-xs font-semibold tracking-wide text-primaryColor uppercase border-b border-gray-200 pb-1 mb-4 mt-8">
                Personal
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 md:gap-x-5 md:items-start">
                <div className="mb-4">
                  <label className="block text-xs text-gray-500 mb-1">
                    Date of Birth
                  </label>
                  <DatePicker
                    selected={date_of_birth}
                    onChange={handleDateChange}
                    dateFormat="MM-dd-yyyy"
                    placeholderText="MM-DD-YYYY"
                    maxDate={maxDate}
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={100}
                    showMonthDropdown
                    shouldCloseOnSelect
                    popperPlacement="top-start"
                    portalId="dob-datepicker-portal"
                    customInput={<DobInput />}
                    className="border-2 border-gray-300 px-3 py-2 rounded-lg !w-full"
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-xs text-gray-500 mb-1">
                    Country
                  </label>
                  <select
                    value={country_of_origin}
                    onChange={(e) => setCountry(e.target.value)}
                    onFocus={() => {
                      if (!countries.length) fetchCountries();
                    }}
                    onMouseDown={() => {
                      if (!countries.length) fetchCountries();
                    }}
                    className={`border-2 px-2 py-2 rounded-lg w-full ${
                      inputsStatus.country === "invalid" &&
                      "border-2 !border-red-500"
                    }`}
                  >
                    <option value="" disabled>
                      {countries.length
                        ? "Select country"
                        : "Loading countries…"}
                    </option>
                    {[
                      ...countries.filter((c) => c.id === country_of_origin),
                      ...countries.filter(
                        (c) =>
                          c.name === "United States" &&
                          c.id !== country_of_origin,
                      ),
                      ...countries.filter(
                        (c) =>
                          c.name !== "United States" &&
                          c.id !== country_of_origin,
                      ),
                    ].map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mb-4">
                <label className="block text-xs text-gray-500 mb-1">
                  Phone Number
                </label>
                <input
                  type="tel"
                  className={`border-2 px-2 py-2 rounded-lg w-full ${
                    inputsStatus.phone === "invalid"
                      ? "!border-red-500"
                      : "border-gray-300"
                  }`}
                  placeholder="3334445555"
                  value={phone}
                  onChange={(e) =>
                    setPhoneNumber(
                      e.target.value.replace(/[^\d\s\-()+]/g, "").slice(0, 20),
                    )
                  }
                  maxLength={20}
                />
              </div>

              <h3 className="text-xs font-semibold tracking-wide text-primaryColor uppercase border-b border-gray-200 pb-1 mb-4 mt-8">
                Links
              </h3>
              <div className="mb-6">
                <label className="block text-xs text-gray-500 mb-1">
                  Website
                </label>
                <input
                  type="text"
                  placeholder="https://yourwebsite.com"
                  className={`border-2 px-2 py-2 rounded-lg w-full ${
                    inputsStatus.link === "invalid" && "border-red-500"
                  }`}
                  value={link && link !== "null" ? link : ""}
                  onChange={(e) => setLink(e.target.value)}
                />
              </div>

              <ProcessingButton
                onClick={handleUpdateProfile}
                processing={saving}
                label="Save changes"
                processingLabel="Saving"
                className="w-full py-3 px-4 mb-24 md:mb-0 bg-[#004c50] hover:bg-[#003a3d] rounded-lg text-white font-medium"
              />
            </div>
          </div>
        </div>
      </PageContainer>
      {guideActive && guideStep === 2 && persona === "creator" && (
        <NewTraderGuide step={2} />
      )}
    </>
  );
};

export default EditProfile;
